import { fromJS, List } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';
import ListUtils from 'portaltransparencia-common/libs/ListUtils.js';

import * as types from './Types.js';

const initialState = fromJS({
  publicacoes: [],
  publicacoesFiltradas: [],
  publicacoesGrupo: [],
  publicacoesGrupoFiltradas: []
});

function publicacaoReducer(state = initialState, action) {
  switch (action.type) {
    case types.PESQUISA_PUBLICACOES_START:
    case types.PESQUISA_PUBLICACOESGRUPO_START: {
      return startLoad(state);
    }

    case types.PESQUISA_PUBLICACOES_SUCCESS: {
      return endLoad(
        state
          .set('publicacoes', fromJS(action.payload))
          .set('publicacoesFiltradas', fromJS(action.payload))
      );
    }

    case types.PESQUISA_PUBLICACOESGRUPO_SUCCESS: {
      return endLoad(
        state
          .set('publicacoesGrupo', fromJS(action.payload))
          .set('publicacoesGrupoFiltradas', fromJS(action.payload))
      );
    }

    case types.PESQUISA_PUBLICACOES_ERROR:
    case types.PESQUISA_PUBLICACOESGRUPO_ERROR: {
      return endLoad(state);
    }

    case types.FILTRAR_PUBLICACOES: {
      const listaFiltrada = ListUtils.filterTreePublicacoes(
        fromJS(action.payload),
        action.meta,
        ['valor'],
        'list'
      );

      return state.set('publicacoesFiltradas', listaFiltrada);
    }

    case types.RESETAR_PUBLICACOES: {
      const publicacoes = state.get('publicacoes').toJS();
      return state.set('publicacoesFiltradas', fromJS(publicacoes));
    }

    case types.FILTRAR_PUBLICACOES_GRUPO: {
      let itensGrupo = fromJS(action.payload).get(0);

      const listaFiltrada = ListUtils.filterTreePublicacoes(
        itensGrupo.get('list'),
        action.meta,
        ['valor'],
        'list'
      );

      itensGrupo = itensGrupo.set('list', listaFiltrada);

      return state.set('publicacoesGrupoFiltradas', List([itensGrupo]));
    }

    case types.RESETAR_PUBLICACOES_GRUPO: {
      const publicacoes = state.get('publicacoesGrupo').toJS();
      return state.set('publicacoesGrupoFiltradas', fromJS(publicacoes));
    }
  }

  return state;
}

export default publicacaoReducer;
